import { render, staticRenderFns } from "./OrdersListFilters.vue?vue&type=template&id=b4e05b66"
import script from "./OrdersListFilters.vue?vue&type=script&lang=js"
export * from "./OrdersListFilters.vue?vue&type=script&lang=js"
import style0 from "./OrdersListFilters.vue?vue&type=style&index=0&id=b4e05b66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports